import MainContentContainer, { MainContentHeader } from 'components/shared/containers/MainContentContainer';
import React from 'react';
import "./styles.css";
import { SVGAsset } from 'res';
import { UICancelButton, UIPrimaryButton } from 'components/ui/UIButton';
import { BCMSDefaultModel, DisabledPrompt, Link, ModalOpen, BCMSRecord, 
StateManager, useBCMSContext, useModel, useRoute, useStateManager, useWorkflow } from '@bcm-dev/bcms-vite';
import Classes, { Card, Destination } from "model";

/**
 * @function UpdateCardOnFilePage
 * @return {React.Component}
 * @exported true
 * @description The page for updating the card on file
 */

export default function UpdateCardOnFilePage(props) {
  const bcmsContext = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, bcmsContext);
  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };
  const { goStep, nextStep, prevStep, state } = useWorkflow() ?? {};

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,
    next: () => nextStep({ data, ui }),
    cancel: () => goStep(1)
  });

  return (
    <StateManager state={ { data, ui } } controller={ controller }>
        <PageContent/>
    </StateManager>
  );
}

export const getDefaultData = () => {
  const cardOnFileMerchant = BCMSDefaultModel.cardOnFileMerchant();
  
  return {
    cardOnFileMerchant
  };
}

export const getDefaultUI = () => ({

});

function PageContent(props) {
  const { data, ui, cancel, next } = useStateManager();
  const navigate = useRoute();
  
  const { user } = useModel();
  const card = data.cardOnFileMerchant.card ?? {};
  const merchant = data.cardOnFileMerchant.merchant ?? {};
  const userState = Destination.states.filter(state => {
    return state.name === user.state;
  })[0];

  return (
    <MainContentContainer className="hide-chevron-icon update-card-on-file-page" header={<MainContentHeader text="Update Card on File" />}>
      <p>Update your card on file with the following card details. This will set it as the default payment method with { merchant.name }.</p>
      <div className="card-details-container">
        <div className="card-detail number flex-container flex-horizontal column-space-between-container">
          <p className="grey-label">Card</p>
          <p>{ `${ card.type } ${ Card.getMaskedNumberFromNumber(card.number) }` }</p>
        </div>
        <div className="card-detail flex-container flex-horizontal column-space-between-container">
          <p className="grey-label">Billing Address</p>
          <div className="text-right">
            <p>{ card.owner }</p>
            <p>{ user.street }</p>
            <p>{ `${ user.city }, ${ userState.abv } ${ user.zip }` }</p>
          </div>
        </div>
        <div className="card-detail flex-container flex-horizontal column-space-between-container">
          <p className="grey-label">Phone Number</p>
          <p>{ user.phoneRevealed }</p>
        </div>
        <div className="card-detail flex-container flex-horizontal column-space-between-container">
          <p className="grey-label">Email ID</p>
          <p>{ user.email }</p>
        </div>
      </div>
      <p className="lower-text">If the information displayed needs to be updated, <DisabledPrompt><Link>contact us.</Link></DisabledPrompt></p>
      <p className="lower-text">You will need your login credentials to the merchant site to continue. </p>
      <div className="grey-section flex-container flex-horizontal align-center-container">
        <SVGAsset id="CheckmarkBadgeIcon" className="set-width left-inline-icon checkmark-badge" />
        <p className="sub-text">Data is encrypted and transmitted over secure channels, and your login credentials will not be stored after the session.</p>
      </div>
      <div className="button-container flex-container flex-vertical all-center-container">
        <UIPrimaryButton text="Continue" onClick={ next } />
        <ModalOpen id="CancelUpdateMerchantModal" data={ { onConfirmClick: cancel } }>
          <UICancelButton text="Cancel" />
        </ModalOpen>
      </div>
    </MainContentContainer>
  );
}